export default __webpack_public_path__ + "static/media/rejected.f33bb00c.svg";